import React, { Component } from "react";


export default class Contactus extends Component {

  renderOld() {
      return (
        <div className="container" id="contactus">
            <h1 className="text-center">Contact Us</h1>
            <div className="row cols-xs-space cols-md-space cols-lg-space">
                <div className="col-lg-4">
                    <div className="card card-blockquote">
                        <div className="card-body">
                            <div className="block-author">
                                <div className="author-image ">
                                    <img src="../../assets/images/prv/people/person-1.jpg" />
                                </div>
                                <div className="author-info">
                                    <span className="d-block heading-6 author-name strong-600 c-base-1">Dr. Mahesh P Shanmugam</span>
                                    <span className="d-block heading-6 author-name strong-600 c-base-1">Founder</span>
                                    <span className="heading-xs author-desc">maheshshanmugam@gmail.com</span>
                                </div>
                            </div>

                            <p className="mt-4 line-height-1_8">
                                Amazing template! All-in-one, clean code, beautiful design, and really not hard to work with.
                                Highly recommended for any kind on website.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="card card-blockquote">
                        <div className="card-body">
                            <div className="block-author">
                                <div className="author-image ">
                                    <img src="../../assets/images/prv/people/person-1.jpg" />
                                </div>
                                <div className="author-info">
                                    <span className="d-block heading-6 author-name strong-600 c-base-1">Dr. Divyansh Mishra</span>
                                    <span className="d-block heading-6 author-name strong-600 c-base-1">Co-Founder</span>
                                    <span className="heading-xs author-desc">drragraj@gmail.com</span>
                                </div>
                            </div>

                            <p className="mt-4 line-height-1_8">
                                Probably the next number one template on the market. Very well structured, updates are regular and consistent, technical support always available. Well done!
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="card card-blockquote">
                        <div className="card-body">
                            <div className="block-author">
                                <div className="author-image ">
                                    <img src="../../assets/images/prv/people/person-1.jpg" />
                                </div>
                                <div className="author-info">
                                    <span className="d-block heading-6 author-name strong-600 c-base-1">Dr. Rajesh R</span>
                                    <span className="d-block heading-6 author-name strong-600 c-base-1">Co-Founder</span>
                                    <span className="heading-xs author-desc">divyansh.mishra@gmail.com</span>
                                </div>
                            </div>

                            <p className="mt-4 line-height-1_8">
                                This is one of the next level Bootstrap theme that is totally worth its value. I appreciate the work
                                done by the Webpixels team and can not wait for the next update.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>


      );
  }


  render(){
    return(

      <div>
        <div className="container-fluid">
        <section className="cta-wrapper">
                  <a href="https://goo.gl/9BbH7R" target="_blank">
                      <div className="slice cta-inner bg-base-1">
                          <div className="flex flex-items-xs-middle">
                              <div className="flex-wrap-item">
                                  <div className="sct-inner ">
                                      <div className="container">
                                          <div className="text-center">
                                              <h1 className="heading heading-3 text-normal c-base-text-1 strong-400">
                                                  CONTACT US
                                              </h1>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </a>
          </section>
          <div className="container mt-4 text-center">

           <br />


          <div className="row cols-xs-space cols-sm-space cols-md-space">
                              <div className="col-lg-4">
                                  <div className="block block--style-3">
                                      <div className="block-body">
                                          <div className="icon-block--style-1-v5 text-center">
                                              <div className="block-icon-lg c-gray-dark">
                                                  <i className="fa fa-envelope"></i>
                                              </div>
                                              <div className="block-content mt-1">
                                                  <h3 className="heading heading-6 strong-600">
                                                      EMAIL CONTACT
                                                  </h3>
                                                  <p>
                                                      For any queries or issues with the website please email us.
                                                  </p>
                                                  <a href="#" className="link link-sm link--style-2 strong-600 c-gray-dark">
                                                      retnetindia@gmail.com
                                                  </a>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <div className="col-lg-4">
                                  <div className="block block--style-3">
                                      <div className="block-body">
                                          <div className="icon-block--style-1-v5 text-center">
                                              <div className="block-icon-lg c-gray-dark">
                                                  <img src="/images/DrRajesh.jpg" className="image-center profile-pic-small"/>
                                              </div>
                                              <div className="block-content mt-1">
                                                  <h3 className="heading heading-6 strong-600">
                                                      Dr. Rajesh Ramanjulu
                                                  </h3>
                                                  <br />
                                                  <p>
                                                      <span className="strong-600 align-left">drragraj@gmail.com</span>
                                                      <br />
                                                      <span className="strong-600 align-left">+91-9036952706</span>

                                                  </p>


                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <div className="col-lg-4">
                                  <div className="block block--style-3">
                                      <div className="block-body">
                                          <div className="icon-block--style-1-v5 text-center">
                                              <div className="block-icon-lg c-gray-dark">
                                                    <img src="/images/divyanshmishra.png" className="image-center profile-pic-small"/>
                                              </div>
                                              <div className="block-content mt-1">
                                                  <h3 className="heading heading-6 strong-600">
                                                     Dr. Divyansh Mishra
                                                  </h3>
                                                  <br />



                                                  <p>
                                                      <span className="strong-600 align-left">divyansh.mishra@gmail.com</span>
                                                      <br />
                                                      <span className="strong-600 align-left">+91-8977405171</span>

                                                  </p>

                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>


                          </div>

            <br />
            <br />
          </div>
        </div>


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Contactus.js